'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.start = start;
exports.stop = stop;
var TIME_THROTTLE = 100;

var elmDoc = document.documentElement;
function refresh() {
  var fz, realfz;
  fz = elmDoc.getBoundingClientRect().width / 10;
  elmDoc.style.fontSize = fz + 'px';
  realfz = +(elmDoc.currentStyle || getComputedStyle(elmDoc, false)).fontSize.replace('px', '');
  if (fz !== realfz) {
    elmDoc.style.fontSize = fz * (fz / realfz) + "px";
  }
}

var timerThrottle = null;
function refreshThrottle() {
  clearTimeout(timerThrottle);
  timerThrottle = setTimeout(refresh, TIME_THROTTLE);
}

function handlePageShow(e) {
  if (e.persisted) {
    refreshThrottle();
  }
}

function handleResize() {
  refreshThrottle();
}

var hasStarted = false;
function start() {
  if (hasStarted) {
    return;
  }

  window.addEventListener('pageshow', handlePageShow, false);
  window.addEventListener('resize', handleResize, false);

  refresh();

  hasStarted = true;
}

function stop() {
  if (!hasStarted) {
    return;
  }

  window.removeEventListener('pageshow', handlePageShow, false);
  window.removeEventListener('resize', handleResize, false);

  hasStarted = false;
}

start();


//////////////////
// WEBPACK FOOTER
// ./~/turbo-flex-rem/lib/index.js
// module id = 21
// module chunks = 8